export enum EnvironmentPollutionType {
  Custom = "Custom",
  Low = "Low",
  Medium = "Medium",
  High = "High",
}

export const DEFAULT_ENVIRONMENT_POLLUTION_TYPE = EnvironmentPollutionType.Medium;

export enum VisualSensorSensitivity {
  Off = "Off",
  Low = "Low",
  Medium = "Medium",
  High = "High",
  VeryHigh = "VeryHigh",
}

export interface EnvironmentPollution {
  type: EnvironmentPollutionType;
  frontBrushSpeed: number;
  rollerBrushSpeed: number;
  aspirationSpeed: number;
  cleaningDrivingSpeed: number;
  brushesBwPeriod: number;
  lidarSensitivity: VisualSensorSensitivity;
  cameraSensitivity: VisualSensorSensitivity;
}

const globalFilter = (v: string) => {
  return v != null;
};

export const getEnvironmentPollutionList = Object.values(EnvironmentPollutionType);
export const getGlobalEnvironmentPollutionList = getEnvironmentPollutionList.filter(globalFilter);
